import React, { Component } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Avatar,
  ListItemAvatar,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

const MapLegendList = withStyles({
  root: {
    paddingTop: "7px",
    paddingBottom: "7px",
    borderRadius: "25px",
    backgroundColor: "white",
    color: "#8091af",
    position: "absolute",
    right: "10px",
    top: "10px",
    zIndex: "1000",
  },
})(List);

const LegendListItemAvatar = withStyles({
  root: {
    minWidth: "0px",
  },
})(ListItemAvatar);

const LegendListItem = withStyles({
  root: {
    paddingLeft: "5px",
    paddingRight: "16px",
    paddingTop: "0px",
    paddingBottom: "0px",
  },
})(ListItem);

const Heading = withStyles({
  root: {},
})(Typography);

class MapLegend extends Component {
  render() {
    return (
      <MapLegendList dense={true}>
        <ListItem alignItems="center">
          <Heading variant="button" color="textPrimary">
          participativní rozpočty
          </Heading>
        </ListItem>
        <LegendListItem>
          <LegendListItemAvatar>
            <Avatar src="./mesta-rozpocet-legend.png" />
          </LegendListItemAvatar>
          <ListItemText primary="město" />
        </LegendListItem>
        <LegendListItem>
          <LegendListItemAvatar>
            <Avatar src="./skoly-rozpocet-legend.png" />
          </LegendListItemAvatar>
          <ListItemText primary="škola" />
        </LegendListItem>
        <ListItem alignItems="center">
          <Heading variant="button" color="textPrimary">
            ostatní projekty
          </Heading>
        </ListItem>
        <LegendListItem>
          <LegendListItemAvatar>
            <Avatar src="./mesta-projekt-legend.png" />
          </LegendListItemAvatar>
          <ListItemText primary="město" />
        </LegendListItem>
        <LegendListItem>
          <LegendListItemAvatar>
            <Avatar src="./skoly-projekt-legend.png" />
          </LegendListItemAvatar>
          <ListItemText primary="škola" />
        </LegendListItem>
        
        {this.renderProviderLegend()}
      </MapLegendList>
    );
  }

  renderProviderLegend() {
    if (this.props.showProviderLegend) {
      return (
        <React.Fragment>
          <ListItem alignItems="center">
            <Heading variant="button" color="textPrimary">
              ostatní
            </Heading>
          </ListItem>
          <LegendListItem>
            <LegendListItemAvatar>
              <Avatar src="./ostatni-legend.png" />
            </LegendListItemAvatar>
            <ListItemText primary="město" />
          </LegendListItem>
        </React.Fragment>
      );
    }
    return null;
  }
}

export default MapLegend;
